
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/ais",
      function () {
        return require("private-next-pages/world/ais/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/ais"])
      });
    }
  